import React from "react";
import ErrorIcon from "./ErrorIcon";
import Spinner from "./Spinner";

import "./LoadingState.scss";

const LoadingState = ({
  children = null,
  error: hasError,
  loading: isLoading,
  ...rest
}) =>
  !hasError && !isLoading ? (
    children
  ) : (
    <div
      {...rest}
      className={`loadingState ${rest.className ? rest.className : ""}`}
    >
      {hasError && <ErrorIcon />}
      {isLoading && <Spinner />}
    </div>
  );

export default LoadingState;
